var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_c('p',{staticClass:"texto-aviso"},[_c('em',{staticClass:"fas fa-info"}),_vm._v(" Em caso de dúvidas ou problemas, por favor entre em contato com "),_c('a',{attrs:{"href":"mailto:proserv-atendimento@usp.br"}},[_vm._v(" proserv-atendimento@usp.br ")])])])
}]

export { render, staticRenderFns }